import { useQuery } from "@tanstack/react-query";
import * as skillsApi from "./skills-api";

/**
 * Workflow-skill catalog for the slash-command list. Pass the current project's
 * `containerId` so that project's skills appear alongside global ones (only in
 * chats within that project). Integration skills are excluded here.
 *
 * When exactly one persona is being targeted for the next message, pass its
 * `aiPersonaId` so the server applies that persona's allowlist and the menu stops
 * offering commands the persona would silently drop. The query key is keyed on
 * the persona so cached catalogs never cross personas.
 */
export function useSkillsQuery(containerId?: string, aiPersonaId?: string) {
  return useQuery({
    queryKey: ["skills", "catalog", containerId ?? "global", aiPersonaId ?? "all-personas"],
    queryFn: async () => {
      const skills = await skillsApi.getSkills({
        ...(containerId ? { containerId } : {}),
        ...(aiPersonaId ? { aiPersonaId } : {}),
      });
      return skills.filter((s) => s.category !== "integration");
    },
    staleTime: 10 * 60 * 1000,
  });
}
